/* eslint-disable react/jsx-fragments */
import React from 'react';
import { useMount } from 'ahooks';
import Loading from 'components/loading/Loading';
import { Card, Row } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import { useSelector } from 'react-redux';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import ExcelExport from 'components/export/ExcelExport';

import { getDataCliente } from './functions';
import { getContestazioni } from './contestazioni.function';

const { SearchBar } = Search;

const CliArt = () => {
  const { caricamentoInCorso, bi } = useSelector((state) => state.bi);

  useMount(getDataCliente);

  const anno = new Date().getFullYear();

  const quattroanni = [
    { dataField: String(anno), text: anno },
    { dataField: String(anno - 1), text: anno - 1 },
    { dataField: String(anno - 2), text: anno - 2 },
    { dataField: String(anno - 3), text: anno - 3 },
  ];

  const getData = (coso) => {
    if (!coso || !Array.isArray(coso)) {
      return [];
    }

    return [...coso]?.sort((a, b) => {
      const nameA = a?.cliente.toUpperCase(); // ignore upper and lowercase
      const nameB = b?.cliente.toUpperCase(); // ignore upper and lowercase
      return nameA?.localeCompare(nameB);
    });
  };

  if (caricamentoInCorso) {
    return <Loading />;
  }

  return (
    <Row>
      {/* Title Start */}
      <section className="scroll-section" id="title">
        <div className="page-title-container">
          <h1 className="mb-0 pb-0 display-4">Customer x Product</h1>
        </div>
      </section>

      <section className="scroll-section">
        <Card body>
          <ToolkitProvider keyField="Id" data={getData(bi)} columns={[{ dataField: 'cliente', text: 'Customer' }, ...quattroanni]} search>
            {(props) => (
              <div>
                <div className="d-flex justify-content-between w-100">
                  <SearchBar {...props.searchProps} />
                  <ExcelExport idTabella="tabella-contratti98" />
                </div>
                <hr />
                <BootstrapTable
                  id="tabella-prodotticustomer"
                  striped
                  bootstrap4
                  condensed
                  wrapperClasses="table-responsive"
                  {...props.baseProps}
                  pagination={paginationFactory({
                    sizePerPage: 10,
                  })}
                />
              </div>
            )}
          </ToolkitProvider>
        </Card>
      </section>
    </Row>
  );
};

export default CliArt;
